module.exports = __webpack_public_path__ + "static/media/derp-personal.de4260d2.png";